import { render, staticRenderFns } from "./ButtonCreateBed.vue?vue&type=template&id=a095185c&"
import script from "./ButtonCreateBed.vue?vue&type=script&lang=js&"
export * from "./ButtonCreateBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports